import { GRACE_PERIOD_FULL_ACCESS_DAYS, GRACE_PERIOD_TOTAL_DAYS } from '@/config/constants'

export const formatBillingDate = (dateString: string | undefined): string => {
	if (!dateString) {
		return 'N/A'
	}
	// Handle invalid backend date (1970-01-01)
	if (dateString === '1970-01-01T00:00:00Z' || dateString.startsWith('1970-01-01')) {
		return '--'
	}

	try {
		const date = new Date(dateString)
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		})
	} catch {
		return dateString
	}
}

export const calculateGracePeriodDays = (expirationDate: string): number => {
	try {
		const expDate = new Date(expirationDate)
		const now = new Date()
		const diffTime = expDate.getTime() - now.getTime()
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
		return Math.max(0, diffDays)
	} catch {
		return 0
	}
}

export const isInGracePeriod = (expirationDate: string): { inGrace: boolean; daysRemaining: number } => {
	const daysRemaining = calculateGracePeriodDays(expirationDate)
	return {
		inGrace: daysRemaining <= GRACE_PERIOD_TOTAL_DAYS && daysRemaining >= 0,
		daysRemaining,
	}
}

export const getGracePeriodStatus = (expirationDate: string): 'full_access' | 'restricted' | 'expired' => {
	const { daysRemaining } = isInGracePeriod(expirationDate)
	if (daysRemaining < 0) {
		return 'expired'
	}
	if (daysRemaining <= GRACE_PERIOD_FULL_ACCESS_DAYS) {
		return 'full_access'
	}
	if (daysRemaining <= GRACE_PERIOD_TOTAL_DAYS) {
		return 'restricted'
	}
	return 'expired'
}
